
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { InAppNotificationClient } from '@/services/Services';
import store from '@/store';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class clubVacationBookingAnswer extends Vue {

    @Prop() item: OM.ClubVacationBookingAnswer;

    onClick(){
        this.$router.push('/network/bookVacation')
        .then(x => {
            this.$emit('clicked');
        });
    }

}
